export const cacheKeys = {
  getSettings: 'getSettings',
};
